const password = {
  // ルールを書くときに使う引数。
  params: ['password'],

  // バリデーションロジック
  validate(field) {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_-]){8,100}/.test(field) 
  },
}

const phone = {
  // ルールを書くときに使う引数。
  params: ['phone'],

  // バリデーションロジック
  validate(field) {
    return /^(?=.*[0-9]{10,11})/.test(field) 
  },
}

const url = {
  // ルールを書くときに使う引数。
  params: ['url'],
  message: '不正なURLです。',
  // バリデーションロジック
  validate(field) {
    return /https?:[/\w!?/+\-_~;.,*&@#$%()'[\]]+/.test(field) 
  },
}

const zip = {
  // ルールを書くときに使う引数。
  params: ['zip'],
  message: '不正な郵便番号です。',
  // バリデーションロジック
  validate(field) {
    return /[0-9]{3}-[0-9]{4}/.test(field) 
  },
}


export { password }
export { phone }
export { url }
export { zip }